import makeStyles from "@mui/styles/makeStyles";

export const useRadioStyles = makeStyles((theme) => ({
  root: {
    width: 24,
    height: 24,
    color: theme.palette.grey[500],
    "& .Radio": {
      stroke: theme.palette.grey[600],
      fill: "transparent",
    },
    "& .Radio-focus": {
      stroke: theme.palette.primary.main,
      fill: "transparent",
      opacity: 0,
    },
    "&:hover": {
      background: "transparent !important",
      "& .Radio": {
        stroke: theme.palette.grey[900],
        fill: "transparent",
      },
    },
    "&:focus-within": {
      "& .Radio-focus": {
        opacity: 0.2,
        fill: "transparent",
      },
    },
    "&.Mui-checked": {
      "& .Radio": {
        stroke: theme.palette.primary.main,
      },
      "&:hover": {
        background: "transparent !important",
        "& .Radio-focus": {
          opacity: 0.2,
        },
      },
      "&:focus-within": {
        "& .Radio": {
          stroke: theme.palette.primary.dark,
        },
      },
      "&.Mui-disabled": {
        "& .Radio": {
          stroke: theme.palette.grey[500],
          fill: theme.palette.grey[300],
        },
        "&:hover": {
          "& .Radio": {
            stroke: theme.palette.grey[500],
            fill: theme.palette.grey[300],
          },
          "& .Radio-focus": {
            opacity: 0,
          },
        },
      },
    },
    "&.Mui-disabled": {
      pointerEvents: "visible",
      cursor: "not-allowed",
      "& .Radio": {
        stroke: theme.palette.grey[300],
        fill: theme.palette.grey[300],
      },
      "&:hover": {
        "& .Radio": {
          stroke: theme.palette.grey[300],
          fill: theme.palette.grey[300],
        },
        "& .Radio-focus": {
          opacity: 0,
        },
      },
    },
  },
}));
